import type { Location, NavigateFunction } from 'react-router-dom';

import type { SearchResult } from '../store/api/searchApi';
import type { GlobalSearchHit } from './globalSearchAggregate';
import { navigateToReferenceCard } from './referenceCardNavigation';

/**
 * Навигация из агрегированного глобального поиска.
 * Справочные карточки открываются поверх текущей страницы (см. backgroundLocation).
 */
export function openGlobalSearchHit(
  hit: GlobalSearchHit,
  navigate: NavigateFunction,
  currentLocation: Location
): void {
  const { type, id } = hit;

  switch (type) {
    case 'application':
      navigate(`/applications/${id}`);
      return;
    case 'route':
      navigate(`/routes/${id}`);
      return;
    case 'counterparty':
      navigateToReferenceCard(navigate, `/contractors/${encodeURIComponent(id)}`, currentLocation);
      return;
    case 'carrier':
      navigateToReferenceCard(navigate, `/carriers/${encodeURIComponent(id)}`, currentLocation);
      return;
    case 'driver':
      navigateToReferenceCard(navigate, `/drivers/${encodeURIComponent(id)}`, currentLocation);
      return;
    default:
      return;
  }
}

/**
 * Навигация из API глобального поиска (и аналогичных мест).
 */
export function openEntity(
  result: SearchResult,
  navigate: NavigateFunction,
  currentLocation: Location
): void {
  const { type, id, url } = result;

  switch (type) {
    case 'application':
      navigate(`/applications/${id}`);
      return;

    case 'route':
      navigate(`/routes/${id}`);
      return;

    case 'tn':
      navigate(`/tn/${id}/view`);
      return;

    case 'contractor':
      navigateToReferenceCard(navigate, `/contractors/${encodeURIComponent(id)}`, currentLocation);
      return;

    case 'driver':
      navigateToReferenceCard(navigate, `/drivers/${encodeURIComponent(id)}`, currentLocation);
      return;

    case 'carrier':
      navigateToReferenceCard(navigate, `/carriers/${encodeURIComponent(id)}`, currentLocation);
      return;

    case 'vehicle':
      navigateToReferenceCard(navigate, `/vehicles/${encodeURIComponent(id)}`, currentLocation);
      return;

    case 'warehouse':
      navigate(url);
      return;

    default:
      navigate(url);
  }
}
